export const WriteRight = "WEB_MODULE_PILOT_COASTAL_SEGMENTS_EVALUATION_WRITE";
export const Rights = [
    WriteRight
]
